import { styled } from '@mui/material/styles';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '12px',
    padding: theme.spacing(1),
    minWidth: '500px'
  }
}));

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.25rem',
  color: '#333',
  paddingBottom: theme.spacing(1)
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5)
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  gap: theme.spacing(2)
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  color: '#666',
  padding: '8px 20px'
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  backgroundColor: '#5E8E7E',
  color: '#fff',
  padding: '8px 30px',
  '&:hover': {
    backgroundColor: '#4A7A6A',
  },
  '&.Mui-disabled': {
    backgroundColor: '#A0B0AB',
    color: '#fff'
  }
}));

export const FormField = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5)
}));
